export const OkrsVI = {
    "okr": {
        "header": {
            "title": "Danh sách mục tiêu OKRs",
            "titleAdd": "Tạo mới mục tiêu",
            "titleUpdate": "Cập nhật mục tiêu",
            "titleDetail": "Chi tiết mục tiêu",
            "generalInformation": "Thông tin chung",
            "titleAddKeyResult": "Tạo mới kết quả then chốt",
            "titleUpdateKeyResult": "Cập nhật kết quả then chốt",
            "titleDetailKeyResult": "Chi tiết kết quả then chốt",
            "titleCheckinKeyResult": "Check in kết quả then chốt",
            "buttonAdd": "Tạo mới",
            "buttonUpdate": "Cập nhật",
            "buttonCancel": "Quay về",
            "buttonSave": "Lưu",
            "proportionConfig": "Cấu hình tỷ trọng",
        },
        "columns": {
            "name": "Tên mục tiêu",
            "description": "Mô tả",
            "parentOKRs": "Mục tiêu cha",
            "childrenOKRs": "Mục tiêu con",
            "keyResult": "Kết quả then chốt",
            "employeeResponsible": "Người chịu trách nhiệm",
            "cycle": "Chu kỳ OKRs",
            "department": "Phòng ban",
            "level": "Cấp OKRs",
            "endDate": "Ngày kết thúc",
            "checkInCycle": "Chu kỳ Check-in",
            "label": "Nhãn",
            "questions": "Nhóm câu hỏi Check-in",
            "question": "Câu hỏi Check-in",
            "objectRelated": "Các bên liên quan",
            "display": "Hiển thị",
            "keyResultName": "Tên kết quả then chốt",
            "measure": "Đo lường kết quả then chốt theo",
            "objectAndKeyResult": "Mục tiêu và Kết quả then chốt",
            "objectChildrenAndKeyResult": "Mục tiêu con và Kết quả then chốt",
            "progress": "Tiến độ",
            "proportion": "Tỷ trọng",
            "effect": "Ảnh hưởng đến mục tiêu cha",
            "checkIn": "Check in",
            "resultInitial": "Ban đầu",
            "result": "Hiện tại",
            "resultTarget": "Mục tiêu",
            "comment": 'Bình luận',
            "autoCalculate": "Tự động",
            "notAutoCalculate": "Tùy chỉnh",
            "taskChildren": "Công việc con",
            "typeMeasure": "Loại kết quả",
            "normalTask": "Công việc thường",
            "processTask": "Công việc theo quy trình"
        },
        "placeholder": {
            "name": "Nhập tên mục tiêu",
            "description": "Nhập mô tả",
            "parentOKRs": "Liên kết với mục tiêu cha",
            "childrenOKRs": "Liên kết với mục tiêu con",
            "keyResult": "Tạo kết quả then chốt",
            "employeeResponsible": "Chọn người chịu trách nhiệm",
            "cycle": "Chọn chu kỳ OKRs",
            "department": "Chọn phòng ban",
            "checkInCycle": "Chọn chu kỳ Check-in",
            "label": "Chọn nhãn",
            "question": "Chọn nhóm câu hỏi",
            "objectRelated": "Chọn các bên liên quan",
            "display": "Hiển thị",
            "resultInitial": "Kết quả ban đầu",
            "resultTarget": "Mục tiêu",
            "processing": "Đang thực hiện",
            "finish": "Hoàn thành",
            "taskChildren": "Liên kết với công việc con",
            "status": "Chọn trạng thái"
        },
        "level": {
            "company": "Công ty",
            "branch": "Chi nhánh",
            "department": "Phòng ban",
            "person": "Cá nhân"
        },
        "display": {
            "public": "Công khai",
            "private": "Cá nhân"
        },
        "measure": {
            "percent": "Phần trăm",
            "number": "Số",
            "status": "Trạng thái"
        },
        "statusCheckin": {
            "checkin": "Check-in đúng giờ",
            "notCheckin": "Chưa check-in",
            "lateCheckin": "Check-in muộn",
            "letCheckin": "Đến ngày check-in"
        },
        "message": {
            "addSuccess": "Tạo mới thành công",
            "updateSuccess": "Cập nhật thành công",
            "deleteObjectAsk": "Bạn có chắc chắn muốn xóa mục tiêu ?",
            "deleteKeyResultAsk": "Bạn có chắc chắn muốn xóa kết quả then chốt ?",
            "saveAnswer": "Lưu câu trả lời thành công",
            "checkInAsk": "Bạn có chắc chắn muốn check in ?",
            "editCheckInAsk": "Bạn có chắc chắn muốn sửa kết quả check in ?",
        }
    }
}